import React from 'react'
import Img from 'gatsby-image'
import { graphql } from 'gatsby'

import { ReactComponent as LinkedIn } from '../../gfx/linkedin.svg'
import MassiveTitle from '../MassiveTitle'

import './style.scss'

const TeamList = ({ data, textData }) => {
  const {
    frontmatter: { intro_title: introTitle, title },
    html,
  } = textData
  return (
    <section className="position-relative c-team-container">
      <div className="u-pull-up d-none d-xl-block">
        <MassiveTitle modifiers={['up', 'left']}>{title}</MassiveTitle>
      </div>
      <div className="container bg-light px-2 py-3 px-sm-4 p-md-5 position-relative">
        <div className="row">
          <div className="col-12 col-md-8">
            <h6>{introTitle}</h6>
            <h2>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </div>
      <div className="position-relative pb-2">
        <div
          className="container bg-light position-absolute"
          style={{
            bottom: 0,
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
        <div className="row justify-content-center pb-0 pb-lg-4 px-1 px-sm-0">
          {data.team_member.map(teamMember => (
            <div
              className=" col-sm-4 col-md-3 col-xl-3 col-xxl-2  mb-1 mb-sm-3 "
              key={teamMember.name + teamMember.function}
            >
              <article className="c-team-member position-relative">
                <div className="c-team-member__content text-white bg-mid text-center p-3 position-absolute d-flex justify-content-center flex-column">
                  <header className="mb-2">
                    <h3 className="mb-0">{teamMember.name}</h3>
                    <div>
                      <i>{teamMember.function}</i>
                    </div>
                  </header>
                  <div className="c-team-member__description mb-3"
                       dangerouslySetInnerHTML={{ __html: teamMember.description }} />
                  {teamMember.linkedin && (
                    <div>
                      <a href={teamMember.linkedin}>
                        <LinkedIn />
                      </a>
                    </div>
                  )}
                </div>
                <Img
                  fluid={teamMember.image.childImageSharp.fluid}
                  alt={teamMember.name}
                />
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TeamList

export const TeamQuery = graphql`
  fragment team on Query {
    team_text: markdownRemark(frontmatter: { id: { eq: "about_team" } }) {
      frontmatter {
        intro_title
        title
      }
      html
    }

    team: aboutYaml(type: { eq: "team" }) {
      team_member {
        name
        function
        description
        linkedin
        image {
          childImageSharp {
            fluid(maxWidth: 300, maxHeight: 300) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`

export const BoardQuery = graphql`
  fragment board on Query {
    board_text: markdownRemark(frontmatter: { id: { eq: "about_board" } }) {
      frontmatter {
        intro_title
        title
      }
      html
    }

    board: aboutYaml(type: { eq: "board" }) {
      team_member {
        name
        function
        description
        linkedin
        image {
          childImageSharp {
            fluid(maxWidth: 300, maxHeight: 300) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`
